// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__A+7Nu","footer__company_name":"footer_footer__company_name__OYxkB","footer__label":"footer_footer__label__oktV0","showFooter":"footer_showFooter__rjzXj"};